<template>
    <form @submit.prevent="login">
        <b-notification :active="!!error"
                        type="is-danger"
                        :has-icon="hasNotificationIcons">
            {{ error }}
        </b-notification>

        <b-notification :active.sync="invalidAccountType"
                        type="is-warning"
                        :has-icon="hasNotificationIcons">
            Du kan ikke logge ind med denne bruger, hvis du vil udføre den nuværende handling.
        </b-notification>

        <b-field :label="$t('global.forms.email')"
                 :type="{ 'is-danger': veeErrors.has('email') }"
                 :message="veeErrors.first('email')">
            <b-input v-model="email"
                     type="email"
                     name="email"
                     v-validate="'required|email'"
                     :data-vv-as="$t('global.forms.email')" />
        </b-field>

        <b-field :label="$t('global.forms.password')"
                 :type="{ 'is-danger': veeErrors.has('password') }"
                 :message="veeErrors.first('password')">
            <b-input v-model="password"
                     type="password"
                     name="password"
                     v-validate="'required'"
                     :data-vv-as="$t('global.forms.password')"
                     password-reveal />
        </b-field>

        <div class="buttons is-right">
            <router-link class="button is-text"
                         :to="{ name: 'auth.password.request' }"
                         @click.native="$emit('close')">
                Glemt kodeord
            </router-link>

            <button type="submit"
                    class="button is-primary"
                    :disabled="veeErrors.any()"
                    :class="{ 'is-loading': isSubmitting }">
                {{ $t('global.actions.login') }}
            </button>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            email: null,
            password: null,
            error: null,
            invalidAccountType: false,
            isSubmitting: false,
        };
    },

    props: {
        allowedAccountTypes: {
            type: Array,
            required: false,
            default: () => ([
                'customer',
                'student',
                'employee',
            ]),
        },

        hasNotificationIcons: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    methods: {
        isAllowedAccountType(accountType) {
            return this.allowedAccountTypes.includes(
                accountType.split('\\').pop().toLowerCase(),
            );
        },

        async login() {
            this.invalidAccountType = false;
            this.error = null;

            if (!await this.$validator.validateAll()) {
                return;
            }

            const { email, password } = this;

            this.isSubmitting = true;

            this.$store
                .dispatch('auth/login', { email, password })
                .then((user) => {
                    this.isSubmitting = false;

                    if (!this.isAllowedAccountType(user.account_type)) {
                        this.invalidAccountType = true;

                        this.$store.dispatch('auth/logout');
                        return;
                    }

                    this.$emit('loggedIn', user);
                    this.$emit('close');

                    return user;
                })
                .then(({ account, latest_conversation_id }) => {
                    // based on user_account_type redirect to the correct page
                    switch (account.type) {
                        case 'customer':
                        case 'student':
                            if (latest_conversation_id) {
                                this.$router.push({ name: 'conversations.conversation', params: { id: latest_conversation_id } });                                
                            } else {
                                this.$router.push({ name: 'users.overview' });                                
                            }
                            break;

                        case 'employee':
                            this.$router.push({ name: 'administration' });
                            break;

                        default:
                            this.$router.push({ name: 'home' });
                            break;
                    }
                })
                .catch(({ response }) => {
                    const { data } = response;

                    this.isSubmitting = false;

                    switch (data.message) {
                        case 'NOT_CONFIRMED':
                            this.error = 'Du har endnu ikke bekræftet din email. Tjek din indbakke og spam-mappe.';
                            break;

                        default:
                            this.error = 'Vi kunne ikke finde en bruger med den kombination af email og kodeord.';
                            break;
                    }
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/infrastructure/auth/components/QuickUserLogin.vue